import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import FdTypography from "../../components/UIComponents/Typography/FdTypography";

// interface IVersion {
//   version: string;
//   number: string;
// }

function createData(version: string, date: string, production: any) {
  return { version, date, production };
}

// const rows = [
//   createData("0.1.0", "02-12-2021"),
//   createData("0.1.1", "03-12-2021"),
// ];

const VersionHistory = () => {
  const [versions, setVersions] = useState<any[]>([]);

  useEffect(() => {
    fetch("/versions.json")
      .then((res) => res.json())
      .then((data) => {
        const versionData = data.map((item: any) =>
          createData(item.version, item.date, item.production)
        );
        setVersions(versionData);
      });
  }, []);

  return (
    <Box p={2}>
      <FdTypography label="Build versions" variant="h4" />
      <FdTypography label="The most recent version (✓) deployed on staging." />
      <Box mt="10px">
        <TableContainer component={Paper} style={{ maxWidth: "700px" }}>
          <Table sx={{minWidth: 650,}} aria-label="simple table">
            <TableBody>
              {versions.map((row, index) => (
                <TableRow key={row.version}>
                  <TableCell component="th" scope="row">
                    v{row.version} {row.production && "(production)"}{" "}
                    {index === 0 && "(✓)"}
                  </TableCell>
                  <TableCell align="right">{row.date}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default VersionHistory;
